const WHATSAPP_LINK = 'https://wa.me/573057096663?text=Hola%2C%20%C2%BFEn%20qu%C3%A9%20podemos%20ayudarte%3F';

interface BrandSectionProps {
  id: string;
  brand: string;
  tagline: string;
  description: string;
  parts: string[];
  accentColor: string;
  accentBg: string;
  accentBorder: string;
  accentBtn: string;
  accentBtnHover: string;
  imageUrl: string;
  imageUrl2: string;
  reversed?: boolean;

}

function BrandSection({
  id,
  brand,
  tagline,
  description,
  parts,
  accentColor,
  accentBg,
  accentBorder,
  accentBtn,
  accentBtnHover,
  imageUrl,
  imageUrl2,
  reversed = false,
}: BrandSectionProps) {
  return (
    <div id={id} className="py-20 border-b border-gray-800/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className={`flex flex-col ${reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12`}>
          {/* Content */}
          <div className="flex-1 w-full">
            <div className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-5 ${accentBg} ${accentColor}`}>
              <i className="ri-car-line"></i>
              {brand}
            </div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-2">
              Repuestos <span className={accentColor}>{brand}</span>
            </h2>
            <div className={`h-1 w-16 rounded-full mb-5 ${accentBtn}`}></div>
            <p className="text-gray-400 text-base leading-relaxed mb-6 max-w-lg">
              {description}
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {parts.map((part) => (
                <li key={part} className="flex items-center gap-2 text-gray-300 text-sm">
                  <span className={`w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 ${accentBg}`}>
                    <i className={`ri-check-line text-xs ${accentColor}`}></i>
                  </span>
                  {part}
                </li>
              ))}
            </ul>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              className={`inline-flex items-center gap-2 ${accentBtn} ${accentBtnHover} text-white font-bold px-7 py-3.5 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer`}
            >
              <i className="ri-whatsapp-line text-base"></i>
              Cotizar repuestos {brand}
            </a>
          </div>

          {/* Images */}
          <div className="flex-1 w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className={`col-span-1 sm:col-span-2 rounded-xl overflow-hidden border ${accentBorder} h-48 sm:h-52 md:h-64`}>
              <img
                src={imageUrl}
                alt={`Repuestos mecánicos ${brand}`}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className={`rounded-xl overflow-hidden border ${accentBorder} h-40 sm:h-36 md:h-44`}>
              <img
                src={imageUrl2}
                alt={`Componentes mecánicos ${brand}`}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className={`rounded-xl ${accentBg} border ${accentBorder} h-40 sm:h-36 md:h-44 flex flex-col items-center justify-center gap-3 p-4`}>
              <i className={`ri-settings-3-line text-3xl md:text-4xl ${accentColor}`}></i>
              <span className="text-white font-bold text-center text-sm">{tagline}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Brands() {
  const brands: BrandSectionProps[] = [
    {
      id: 'chevrolet',
      brand: 'Chevrolet',
      tagline: 'Disponibilidad inmediata en Bogotá',
      description: 'El portafolio más completo de repuestos mecánicos para Chevrolet en Bogotá. Motor, caja, suspensión y frenos — disponibles ahora. Asesoría técnica incluida sin costo adicional.',
      parts: ['Motor y culata', 'Caja de cambios', 'Suspensión delantera', 'Sistema de frenos', 'Dirección hidráulica', 'Amortiguadores', 'Correas y cadenas', 'Empaques de motor'],
      accentColor: 'text-blue-400',
      accentBg: 'bg-blue-500/10',
      accentBorder: 'border-blue-500/30',
      accentBtn: 'bg-blue-600',
      accentBtnHover: 'hover:bg-blue-700',
      imageUrl: 'https://readdy.ai/api/search-image?query=Chevrolet%20car%20engine%20mechanical%20parts%20close%20up%20automotive%20repair%20shop%20dark%20background%20professional%20lighting%20chrome%20metal%20components%20high%20detail%20industrial%20photography&width=600&height=400&seq=chev001&orientation=landscape',
      imageUrl2: 'https://readdy.ai/api/search-image?query=Chevrolet%20suspension%20parts%20brake%20discs%20mechanical%20components%20dark%20studio%20background%20automotive%20spare%20parts%20professional%20photography&width=300&height=300&seq=chev002&orientation=squarish',
      reversed: false,
    },
    {
      id: 'suzuki',
      brand: 'Suzuki',
      tagline: 'Stock permanente para toda la línea Suzuki',
      description: 'Repuestos mecánicos para toda la línea Suzuki con entrega rápida en Bogotá. Originales y alternativos de calidad certificada. Cotiza ahora y recibe atención inmediata.',
      parts: ['Reparación completa de motor', 'Transmisión manual', 'Ejes y cardanes', 'Sistema de frenos', 'Suspensión trasera', 'Amortiguadores', 'Bomba de agua', 'Embrague completo'],
      accentColor: 'text-red-400',
      accentBg: 'bg-red-500/10',
      accentBorder: 'border-red-500/30',
      accentBtn: 'bg-red-600',
      accentBtnHover: 'hover:bg-red-700',
      imageUrl: 'https://readdy.ai/api/search-image?query=Suzuki%20Jimny%20compact%20SUV%20red%20car%20parked%20clean%20dark%20background%20studio%20automotive%20photography%20professional%20side%20view%20sharp%20details%20high%20quality&width=600&height=400&seq=suzu003&orientation=landscape',
      imageUrl2: 'https://readdy.ai/api/search-image?query=Suzuki%20brake%20system%20suspension%20components%20mechanical%20parts%20dark%20background%20automotive%20photography%20professional&width=300&height=300&seq=suzu002&orientation=squarish',
      reversed: true,
    },
    {
      id: 'jeep',
      brand: 'Jeep',
      tagline: 'Repuestos 4x4 para el terreno colombiano',
      description: 'Repuestos mecánicos de alta resistencia para toda la gama Jeep. Piezas que aguantan las condiciones más exigentes. Atención especializada y respuesta inmediata por WhatsApp.',
      parts: ['Piezas de motor', 'Caja de transferencia', 'Diferencial delantero', 'Suspensión', 'Amortiguadores', 'Sistema de frenos', 'Cardán y crucetas', 'Bomba hidráulica'],
      accentColor: 'text-green-400',
      accentBg: 'bg-green-500/10',
      accentBorder: 'border-green-500/30',
      accentBtn: 'bg-green-700',
      accentBtnHover: 'hover:bg-green-800',
      imageUrl: 'https://readdy.ai/api/search-image?query=Jeep%204x4%20engine%20mechanical%20parts%20rugged%20automotive%20components%20dark%20dramatic%20background%20professional%20photography%20metal%20chrome%20industrial%20look&width=600&height=400&seq=jeep001&orientation=landscape',
      imageUrl2: 'https://readdy.ai/api/search-image?query=Jeep%20suspension%20off%20road%20mechanical%20parts%20dark%20background%20automotive%20spare%20parts%20professional%20studio&width=300&height=300&seq=jeep002&orientation=squarish',
      reversed: false,
    },
    {
      id: 'ram',
      brand: 'RAM',
      tagline: 'Repuestos para camionetas de trabajo',
      description: 'Repuestos mecánicos para camionetas RAM de uso intensivo y trabajo pesado. Piezas de alta resistencia con garantía. Cotiza por WhatsApp y recibe respuesta en minutos.',
      parts: ['Motor diésel y gasolina', 'Transmisión automática', 'Diferencial trasero', 'Sistema de frenos', 'Suspensión de carga', 'Amortiguadores reforzados', 'Turbocompresor', 'Bomba de combustible'],
      accentColor: 'text-slate-300',
      accentBg: 'bg-slate-500/10',
      accentBorder: 'border-slate-500/30',
      accentBtn: 'bg-slate-700',
      accentBtnHover: 'hover:bg-slate-800',
      imageUrl: 'https://readdy.ai/api/search-image?query=RAM%20truck%20powerful%20engine%20mechanical%20parts%20heavy%20duty%20automotive%20components%20dark%20background%20dramatic%20lighting%20professional%20photography%20industrial&width=600&height=400&seq=ram001&orientation=landscape',
      imageUrl2: 'https://readdy.ai/api/search-image?query=RAM%20truck%20brake%20suspension%20mechanical%20components%20dark%20studio%20background%20automotive%20spare%20parts%20professional&width=300&height=300&seq=ram002&orientation=squarish',
      reversed: true,
    },
    {
      id: 'dodge',
      brand: 'Dodge',
      tagline: 'Potencia y disponibilidad garantizada',
      description: 'Repuestos mecánicos originales y alternativos para toda la línea Dodge. Motor, transmisión y suspensión con disponibilidad inmediata en Bogotá. Asesoría técnica sin costo adicional.',
      parts: ['Motor V6 y V8', 'Transmisión automática', 'Diferencial trasero', 'Sistema de frenos', 'Suspensión delantera', 'Amortiguadores', 'Dirección asistida', 'Bomba de aceite'],
      accentColor: 'text-rose-400',
      accentBg: 'bg-rose-500/10',
      accentBorder: 'border-rose-500/30',
      accentBtn: 'bg-rose-700',
      accentBtnHover: 'hover:bg-rose-800',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dodge%20muscle%20car%20V8%20engine%20mechanical%20parts%20automotive%20components%20dark%20dramatic%20background%20professional%20photography%20chrome%20metal%20industrial%20high%20detail%20workshop&width=600&height=400&seq=dodge001&orientation=landscape',
      imageUrl2: 'https://readdy.ai/api/search-image?query=Dodge%20brake%20caliper%20suspension%20mechanical%20spare%20parts%20dark%20studio%20background%20automotive%20professional%20photography%20high%20quality&width=300&height=300&seq=dodge002&orientation=squarish',
      reversed: false,
    },
    {
      id: 'isuzu',
      brand: 'Isuzu',
      tagline: 'Especialistas en diésel Isuzu',
      description: 'Repuestos mecánicos para vehículos y camiones Isuzu diésel. Stock permanente en motores, cajas y sistemas de inyección. Respuesta inmediata y envío a todo Colombia.',
      parts: ['Motor diésel', 'Sistema de inyección', 'Turbocompresor', 'Caja de cambios', 'Diferencial', 'Sistema de frenos', 'Suspensión de carga', 'Bomba de combustible'],
      accentColor: 'text-amber-400',
      accentBg: 'bg-amber-500/10',
      accentBorder: 'border-amber-500/30',
      accentBtn: 'bg-amber-600',
      accentBtnHover: 'hover:bg-amber-700',
      imageUrl: 'https://readdy.ai/api/search-image?query=Isuzu%20D-Max%20pickup%20truck%20white%20heavy%20duty%20commercial%20vehicle%20parked%20clean%20dark%20background%20studio%20automotive%20photography%20professional%20side%20view%20sharp%20details&width=600&height=400&seq=isuzu003&orientation=landscape',
      imageUrl2: 'https://readdy.ai/api/search-image?query=Isuzu%20diesel%20injection%20turbo%20mechanical%20spare%20parts%20dark%20studio%20background%20automotive%20professional%20photography%20amber%20tones&width=300&height=300&seq=isuzu002&orientation=squarish',
      reversed: true,
    },
  ];

  return (
    <section id="marcas" className="bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-4 text-center">
        <div className="inline-flex items-center gap-2 border border-[#2563eb]/40 text-[#2563eb] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
          <i className="ri-car-line"></i>
          Repuestos por Marca
        </div>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
          Encuentra el Repuesto<br /><span className="text-[#2563eb]">para Tu Vehículo</span>
        </h2>
        <p className="text-gray-400 text-base max-w-2xl mx-auto">
          Chevrolet, Suzuki, Jeep, RAM, Dodge e Isuzu — cotiza directamente por WhatsApp. Atención inmediata, disponibilidad real, sin rodeos.
        </p>
      </div>

      {brands.map((brand) => (
        <BrandSection key={brand.id} {...brand} />
      ))}
    </section>
  );
}
